/* eslint-disable react/no-array-index-key */
import React from 'react';
import Clipboard from '../Clipboard';
import PropTypes from 'prop-types';
import { JsonView, defaultStyles } from 'react-json-view-lite';

defaultStyles.container = `overflow-auto inner`;

const JsonViewer = ({ data, className }) => {
  const styles = defaultStyles;

  styles.container = `overflow-auto inner ${className?.code ?? ''}`;

  return (
    <div className={`json-viewer ${className?.wrapper ?? ''}`}>
      <Clipboard
        item={{ label: 'Data ', value: data }}
        className="text-blue json-clip"
      />
      <div className={className?.code}>
        <JsonView data={data} style={styles} />
      </div>
    </div>
  );
};

JsonViewer.propTypes = {
  data: PropTypes.object,
  className: {
    wrapper: '',
    code: ''
  }
};

export default JsonViewer;
